import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import Collection from "@/sections/Collection";
import Advantages from "@/sections/Advantages";
import Clients from "@/sections/Clients";
import Testimonials from "@/sections/Testimonials";
import Inquiry from "@/sections/Inquiry";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";
import WhatsappFab from "@/sections/WhatsappFab";
import AdminLeads from "@/pages/AdminLeads";

const Home = () => {
  return (
    <main className="bg-[#FAF8F5] text-slate-900 antialiased" data-testid="home-page">
      <Navbar />
      <Hero />
      <Collection />
      <Advantages />
      <Clients />
      <Testimonials />
      <Inquiry />
      <Contact />
      <Footer />
      <WhatsappFab />
    </main>
  );
};

function App() {
  // Strip injected Emergent watermark badge (per owner's request).
  // Runs once on mount; MutationObserver + timeouts handle late injections.
  useEffect(() => {
    const strip = () => {
      const ids = ["emergent-badge"];
      ids.forEach((i) => {
        const el = document.getElementById(i);
        if (el) el.remove();
      });
      document
        .querySelectorAll('a[href*="emergent.sh"], a[href*="emergent.host"]')
        .forEach((el) => el.remove());
      // Catch any injected "Made with Emergent" badge regardless of markup
      document.querySelectorAll("body > *").forEach((el) => {
        if (el.id === "root" || el.tagName === "SCRIPT" || el.tagName === "NOSCRIPT" || el.tagName === "STYLE") return;
        if (/made with emergent/i.test(el.textContent || "")) el.remove();
      });
    };
    strip();
    const t1 = setTimeout(strip, 300);
    const t2 = setTimeout(strip, 1500);
    const obs = new MutationObserver(strip);
    obs.observe(document.documentElement, { childList: true, subtree: true });
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      obs.disconnect();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
